import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-banner-cv',
    templateUrl: './banner-cv.component.html',
    styleUrls: ['./banner-cv.component.scss'],
    standalone: false
})
export class BannerCvComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
